import styles from './documentSectionListPanel.module.css'
import type { ReactNode } from 'react'
import { Button, ButtonKind, DetailFieldProps, FieldList, Section } from '../../../ui'

export type DocumentSectionAction = {
    icon: string
    label?: string
    kind?: ButtonKind
    onClick: () => void
}

export type DocumentSection = {
    id: string
    title: ReactNode
    titleExpanded?: ReactNode
    fields?: DetailFieldProps[]
    content?: JSX.Element | JSX.Element[]
    headerActions: DocumentSectionAction[]
    defaultExpanded?: boolean
}

type Props = {
    sections: DocumentSection[]
    // Bootstrap columns of each section (12 to fill the width, e.g. when nested inside another section)
    space?: number
}

export const DocumentSectionListPanel = (props: Props) => {
    const { sections, space = 8 } = props

    const hasSectionContent = (section: DocumentSection) =>
        !!section.content || (section.fields?.length ?? 0) > 0
    
    const renderSectionContent = (section: DocumentSection) => {
        if (section.content) {
            return section.content
        }
        if (section.fields && section.fields.length > 0) {
            return <FieldList fields={section.fields} />
        }
        return undefined
    }

    return (
        <div className={styles.container}>
            {sections.map(section => (
                <Section
                    key={section.id}
                    id={section.id}
                    title={section.title}
                    titleExpanded={section.titleExpanded}
                    collapsable={hasSectionContent(section)}
                    space={space}
                    defaultExpanded={section.defaultExpanded}
                    headerActions={section.headerActions.map((action, index) => (
                        <Button
                            key={index}
                            icon={action.icon}
                            kind={action.kind || 'tertiary'}
                            label={action.label}
                            small
                            onClick={action.onClick}
                        />
                    ))}
                >
                    {renderSectionContent(section)}
                </Section>
            ))}
        </div>
    )
}
